import { roleConstants } from '../_constants/adminRole.constants'
const initialState =  {};
 function adminRoleReducer(state = initialState, action) {
  switch (action.type) {
    case roleConstants.ROLE_SUCCESS:
      console.log("data",action.roleData)
      return {
         roleData : action.roleData
         };
    default:
      return state
  }
}

export default adminRoleReducer;